import {Button} from '@mui/material'
import {styled} from 'styled-components'
import {screenS} from '@theme/vars'

export const RHFSearchPublicationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 726px;

  @media (max-width: ${screenS}) {
    flex-direction: column;

    & div {
      width: 100%;
    }
  }
`

export const ButtonWrapper = styled(Button)`
  width: 160px;
  margin-left: 16px;

  @media (max-width: ${screenS}) {
    width: 100%;
    margin-left: 0px;
    margin-top: 16px;
  }
`
